import React, { useState } from 'react';
import { Menu, ChevronDown, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '../ui/dropdown-menu';

/* SVG ASSETS */
import userIcon from '../../assets/display-pic.png';
import contactIcon from '../../assets/support-svgrepo-com.svg';
import whatsappIcon from '../../assets/whatsapp-icon-logo-svgrepo-com.svg';
import phoneIcon from '../../assets/profile-plus-1357-svgrepo-com.svg';
import emailIcon from '../../assets/email-1573-svgrepo-com.svg';
import siteIcon from '../../assets/site-svgrepo-com.svg';
import settingsIcon from '../../assets/setting-line-svgrepo-com.svg';
import logoutIcon from '../../assets/logout-circle-r-fill-svgrepo-com.svg';

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showContact, setShowContact] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      {/* HEADER */}
      <header className="sticky top-0 z-30 h-14 bg-white border-b border-gray-200">
        <div className="flex h-full items-center justify-between px-4 lg:px-6">

          {/* LEFT */}
          <div className="flex items-center gap-3">
            <button
              onClick={onMenuClick}
              className="lg:hidden p-2 rounded-md hover:bg-gray-100"
            >
              <Menu className="w-5 h-5 text-gray-700" />
            </button>

            <span className="hidden sm:block text-sm font-semibold text-gray-800">
              Wilson Garden
            </span>
          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-3">

            {/* CONTACT BUTTON */}
            <button
              onClick={() => setShowContact(true)}
              className="w-9 h-9 rounded-md hover:bg-gray-100 flex items-center justify-center"
              title="Contact"
            >
              <img src={contactIcon} alt="Contact" className="w-5 h-5" />
            </button>

            {/* USER MENU */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="flex items-center gap-2 px-2 py-1 rounded-md hover:bg-gray-100">
                  <div className="w-8 h-8 rounded-full border bg-gray-50 overflow-hidden">
                    <img src={userIcon} alt="User" className="w-full h-full" />
                  </div>

                  <div className="hidden sm:block text-left">
                    <p className="text-sm font-medium text-gray-800 truncate max-w-[140px]">
                      {user?.full_name || 'User'}
                    </p>
                    <p className="text-xs text-gray-500">{user?.role}</p>
                  </div>

                  <ChevronDown className="hidden sm:block w-4 h-4 text-gray-400" />
                </button>
              </DropdownMenuTrigger>

              {/* DROPDOWN */}
              <DropdownMenuContent
                align="end"
                className="w-64 bg-white border border-gray-200 rounded-xl shadow-xl p-0"
              >
                <div className="px-4 py-3 border-b">
                  <p className="text-sm font-semibold truncate">
                    {user?.full_name}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {user?.email}
                  </p>
                </div>

                <div className="p-2">
                  <button
                    onClick={() => navigate('/profile')}
                    className="w-full flex items-center gap-3 px-3 py-2 rounded-md hover:bg-gray-100 text-sm"
                  >
                    <img src={settingsIcon} className="w-4 h-4" />
                    Profile Settings
                  </button>
                </div>

                <div className="border-t p-2">
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm font-semibold"
                    style={{ background: '#FEE2E2', color: '#991B1B' }}
                  >
                    <img src={logoutIcon} className="w-4 h-4" />
                    Logout
                  </button>
                </div>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </header>

      {/* CONTACT MODAL */}
      {showContact && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="bg-white rounded-xl w-[90%] max-w-sm shadow-xl">
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <p className="text-sm font-semibold">Contact</p>
              <button onClick={() => setShowContact(false)}>
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            <div className="p-4 space-y-4 text-sm">
              <a
                href="https://wa.me/919380078320"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-black"
              >
                <img src={whatsappIcon} className="w-4 h-4" />
                WhatsApp: 9380078320
              </a>

              <a
                href="tel:+919380078320"
                className="flex items-center gap-3 hover:text-black"
              >
                <img src={phoneIcon} className="w-4 h-4" />
                Call Now
              </a>

              <a
                href="mailto:info@vangtechnologies.in"
                className="flex items-center gap-3 hover:text-black"
              >
                <img src={emailIcon} className="w-4 h-4" />
                info@vangtechnologies.in
              </a>

              <a
                href="https://www.vangtechnologies.in"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-black"
              >
                <img src={siteIcon} className="w-4 h-4" />
                vangtechnologies.in
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
